import { render, staticRenderFns } from "./SanRanking.vue?vue&type=template&id=5750b9a3&scoped=true"
import script from "./SanRanking.vue?vue&type=script&lang=js"
export * from "./SanRanking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5750b9a3",
  null
  
)

export default component.exports